/**
 * When to open a new EventSource after one errored. The browser retries a dropped connection
 * itself, but a non-200 answer (a 502 while the server restarts) closes it for good.
 */
export const FIRST_BACKOFF_MS = 1000;
export const MAX_BACKOFF_MS = 30_000;

/** Milliseconds to wait before opening a new stream, or null to leave it alone. */
export function retryAfter(opts: { readyState: number; closedForGood: boolean; backoffMs: number }): number | null {
	// CLOSED is 2 in every browser and in node; the enum is not available outside a DOM.
	if (opts.readyState !== 2) return null; // still connecting or open: the browser is on it
	if (opts.closedForGood) return null; // the session cannot start, or is no longer shared
	return opts.backoffMs;
}

export function nextBackoff(backoffMs: number): number {
	return Math.min(backoffMs * 2, MAX_BACKOFF_MS);
}
